import { React, useState } from 'react';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { ResponsiveImage } from '../../components';
import { formatMoney } from '../../util/currency';
import { createSlug } from '../../util/urlHelpers';
import { getAgeRange } from '../../util/ageUtils';
import { BsFillArrowRightCircleFill } from 'react-icons/bs';
import { AiFillStar } from 'react-icons/ai';
import { AiFillInstagram } from 'react-icons/ai';
import classNames from 'classnames';
import css from './ListingCard.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
import config from '../../config';
import moment from 'moment';
import Decimal from 'decimal.js';
import NoIGLinkPopup from '../../containers/NoIGLinkPopup/NoIGLinkPopup';

const { Money } = sdkTypes;
function ProductCard({
  title,
  id,
  description,
  price,
  images,
  publicData,
  customImage,
  intl,
  authorName = 'Test Name',
  geolocation,
  listing,
  metadata,
  profileMetadata,
}) {
  const [showPopup, setShowPopup] = useState(false);

  // Function to toggle popup
  const togglePopup = () => setShowPopup(!showPopup);

  const history = useHistory();
  const instagram = profileMetadata?.instagram || null;
  const instagramLink = instagram ? 'https://instagram.com/' + String(instagram) : '';
  const { dob, gender } = publicData;
  const getTitle = title => (title?.length > 30 ? title.substring(0, 19) + '...' : title || '');
  const formattedPrice = formatMoney(intl, new Money(1000, config.currency));
  const dateOfBirth = moment(dob, 'YYYY-MM-DD');
  const exactAge = dateOfBirth
    ? parseInt(moment.duration(moment().diff(dateOfBirth)).asYears(), 10)
    : null;
  const ageRange = getAgeRange(exactAge);

  const handleClick = () => {
    history.push({
      pathname: `/l/${createSlug(title)}/${id}`,
    });
  };

  const stars = metadata?.avgRating;
  const avgRating = stars ? new Decimal(stars).div(100).toNumber() : null;
  
  // TEMP: Force display 5 star rating for UI testing
  // To disable: Comment out the next line and uncomment the one below it
  // const displayRating = 4.2; 
  const displayRating = avgRating;

  return (
    <div className={css.product}>
      <div onClick={handleClick}>
        <div className={classNames(css.productImageWrapper, 'relative')}>
          <div className={css.imageOverlay} />
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={title}
            image={images[0]}
            variants={['default']}
            // customImage={customImage}
          />
          
          {/* IG Logic Commented Out
          {instagramLink ? (
            <div 
              className={css.igBadge} 
              onClick={(e) => {
                e.stopPropagation();
                togglePopup();
              }}
            >
              <AiFillInstagram className={css.icon} />
            </div>
          ) : null}
          */}
          
          <div className={css.overlayContent}>
            <div className={css.name}>{authorName?.toLowerCase()}</div>
            <div className={css.infoRow}>
              {ageRange && (
                <span className={css.ageOnImage}>
                  {ageRange} y/o
                </span>
              )}
              {/* Always show rating if displayRating is set (for testing) or avgRating exists */}
              {(displayRating || avgRating) && (
                 <div className={css.ratingContainerOverlay}>
                   <span className={css.ratingSeparator}>•</span>
                   <span className={css.ratingValueOverlay}>{displayRating || avgRating}</span>
                   <AiFillStar className={css.starOverlay} />
                 </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showPopup && <NoIGLinkPopup closePopup={togglePopup} />}

    </div>
  );
}

export default injectIntl(ProductCard);
